export default __webpack_public_path__ + "static/media/inicio-temporada.78c24bea.gif";